<template>
<section id="service" class="home-service tab bg-sand">
	<div class="container">
		<div class="row">
			<div class="col-sm-8 offset-sm-2 col-xs-12 text-center">
				<div class="sectionTitle">
					<span style="color:#2c9eda;text-transform:initial">Servicios</span>
					<h2 style="color:#222222;text-transform:lowercase" >especializados</h2>
				</div>
			</div>
		</div>
		<!-- Tabs row starts here -->
		 <div class="row">
			<div class="col-md-12">
				<ul class="nav nav-tabs icon_tabs nav-justified" role="tablist">
				  <li class="nav-item text-center">
				    <a class="nav-link active" href="#tab1" role="tab" data-toggle="tab" @click="switchImage(1)" ref="ejecucion">
				    	<!-- <i class="fa fa-cog" aria-hidden="true"></i> -->
                        <img src="/src/assets/img/icono-ejecucion-gris.png">
				    	<h3>Ejecución</h3>
				    </a>
				  </li>
				  <li class="nav-item text-center">
				    <a class="nav-link" href="#tab2" role="tab" data-toggle="tab" @click="switchImage(2)" ref="promocion">
				    	<!-- <i class="fa fa-bed" aria-hidden="true"></i> -->
                        <img src="/src/assets/img/icono-promocion-gris.png">
				    	<h3>Promoción</h3>
				    </a>
				  </li>
				  <li class="nav-item text-center">
				    <a class="nav-link" href="#tab3" role="tab" data-toggle="tab" @click="switchImage(3)" ref="investigacion">
				    	<!-- <i class="	fa fa-signing"></i> -->
                        <img src="/src/assets/img/icono-investigacion-gris.png">
				    	<h3>Investigación de mercados</h3>
				    </a>
				  </li>
				  <li class="nav-item text-center">
				    <a class="nav-link" href="#tab4" role="tab" data-toggle="tab" @click="switchImage(4)" ref="mercadotecnia">
				    	<!-- <i class="fa fa-cubes"></i> -->
                        <img src="/src/assets/img/icono-mercadotecnia-gris.png">
				    	<h3>Mercadotecnia</h3>
				    </a>
				  </li>
				  <li class="nav-item text-center">
				    <a class="nav-link" href="#tab5" role="tab" data-toggle="tab" @click="switchImage(5)" ref="capacitacion">
				    	<!-- <i class="fa fa-graduation-cap"></i> -->
                        <img src="/src/assets/img/icono-capacitacion-gris.png">
				    	<h3>Capacitación</h3>
				    </a>
				  </li>
				</ul>

				<!-- Tab panes -->
				<div class="tab-content">
           			<div role="tabpanel" class="tab-pane fade show active" id="tab1">
						<div class="row tab-content">
							<div class="col-xs-5 col-md-5 push-md-7">
								<div class="service_image">
									<img src="/src/assets/img/SE1-Ejecucion.png" alt="image">
								</div>
							</div>
							<div class="col-xs-7 col-md-7 pull-md-5">
								<div class="tab-content_left">
									<h3>Ejecución</h3>
									<p>
									   Ejecutamos campañas publicitarias alineadas a la estrategia:
									</p>
                                  <ul class="styled_list">
										<li class=""><a href="#"><i class="fa fa-circle-o"></i> Alcance nacional e internacional</a></li>
										<li class=""><a href="#"><i class="fa fa-circle-o"></i> Servicios 360°</a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
            	<div role="tabpanel" class="tab-pane fade show" id="tab2">
						<div class="row tab-content">
							<div class="col-xs-5 col-md-5 push-md-7">
								<div class="service_image">
									<img src="/src/assets/img/SE2-Promocion.png" alt="image">
								</div>
							</div>
							<div class="col-xs-7 col-md-7 pull-md-5">
								<div class="tab-content_left">
									<h3>Promoción</h3>
									<p>
									  Brindamos servicios especializados de promoción e impulso para llevar tu marca al siguiente nivel.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div role="tabpanel" class="tab-pane fade show" id="tab3">
						<div class="row tab-content">
							<div class="col-xs-5 col-md-5 push-md-7">
								<div class="service_image">
									<img src="/src/assets/img/SE3-Inv-Mercados.png" alt="image">
								</div>
							</div>
							<div class="col-xs-7 col-md-7 pull-md-5">
								<div class="tab-content_left">
									<h3>Investigación de mercados</h3>
									<p>
									   Contamos con experiencia desarrollando muestras, encuestas, BI, análisis de data, pronósticos, etc.
									</p>
								</div>
							</div>
						</div>
					</div>
           <div role="tabpanel" class="tab-pane fade show" id="tab4">
						<div class="row tab-content">
							<div class="col-xs-5 col-md-5 push-md-7">
								<div class="service_image">
									<img src="/src/assets/img/SE4-Mercadotecnia.png" alt="image">
								</div>
							</div>
							<div class="col-xs-7 col-md-7 pull-md-5">
								<div class="tab-content_left">
									<h3>Mercadotecnia</h3>
									<p>
									   Nuestra experiencia nos permite crear estrategias integrales de marketing. B2B, B2C.
									</p>
								</div>
							</div>
						</div>
					</div>
            <div role="tabpanel" class="tab-pane fade show" id="tab5">
						<div class="row tab-content">
							<div class="col-xs-5 col-md-5 push-md-7">
								<div class="service_image">
									<img src="/src/assets/img/SE5-Capacitacion.png" alt="image">
								</div>
							</div>
							<div class="col-xs-7 col-md-7 pull-md-5">
								<div class="tab-content_left">
									<h3>Capacitación</h3>
									<p>
									  Evoluciona el concepto de aprendizaje, de la mano de los expertos.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div><!-- Tabs row starts here -->
	</div>
</section>
</template>

<script>
export default {
  name: 'Services',
  data() {
    return {
		c:[]
    }
  },
  created() {
  },
  methods:{ 
	  switchImage(i) {
      debugger
	   switch (i)
	   {
		   case 1:
			    this.e = this.$refs.ejecucion;
				this.e.children[0].src= '/src/assets/img/icono-ejecucion-hover.png';
				this.p = this.$refs.promocion;
				this.p.children[0].src= '/src/assets/img/icono-promocion-gris.png';	
				this.i = this.$refs.investigacion;	
				this.i.children[0].src= '/src/assets/img/icono-investigacion-gris.png'
				this.m = this.$refs.mercadotecnia;
				this.m.children[0].src= '/src/assets/img/icono-mercadotecnia-gris.png';	
				this.c = this.$refs.capacitacion;
				this.c.children[0].src= '/src/assets/img/icono-capacitacion-gris.png';	
					
			    break;
			case 2:
				this.e = this.$refs.ejecucion;
				this.e.children[0].src= '/src/assets/img/icono-ejecucion-gris.png';
				this.p = this.$refs.promocion;
				this.p.children[0].src= '/src/assets/img/icono-promocion-hover.png';
				this.i = this.$refs.investigacion;	
				this.i.children[0].src= '/src/assets/img/icono-investigacion-gris.png'
				this.m = this.$refs.mercadotecnia;
				this.m.children[0].src= '/src/assets/img/icono-mercadotecnia-gris.png';	
				this.c = this.$refs.capacitacion;
				this.c.children[0].src= '/src/assets/img/icono-capacitacion-gris.png';	
					
				break;
			case 3:
				this.e = this.$refs.ejecucion;
				this.e.children[0].src= '/src/assets/img/icono-ejecucion-gris.png';
				this.p = this.$refs.promocion;
			   	this.p.children[0].src= '/src/assets/img/icono-promocion-gris.png';	
				this.i = this.$refs.investigacion;
				this.i.children[0].src= '/src/assets/img/icono-investigacion-hover.png';
				this.m = this.$refs.mercadotecnia;
				this.m.children[0].src= '/src/assets/img/icono-mercadotecnia-gris.png';	
				this.c = this.$refs.capacitacion;
				this.c.children[0].src= '/src/assets/img/icono-capacitacion-gris.png';	
					
				break;
			case 4:
				this.e = this.$refs.ejecucion;
				this.e.children[0].src= '/src/assets/img/icono-ejecucion-gris.png';
				this.p = this.$refs.promocion;
			   	this.p.children[0].src= '/src/assets/img/icono-promocion-gris.png';	
				this.i = this.$refs.investigacion;	
				this.i.children[0].src= '/src/assets/img/icono-investigacion-gris.png';	
				this.m = this.$refs.mercadotecnia;
				this.m.children[0].src= '/src/assets/img/icono-mercadotecnia-hover.png';
					
				this.c = this.$refs.capacitacion;
				this.c.children[0].src= '/src/assets/img/icono-capacitacion-gris.png';	
				break;
			case 5:
				this.e = this.$refs.ejecucion;
				this.e.children[0].src= '/src/assets/img/icono-ejecucion-gris.png';
				this.p = this.$refs.promocion;
			   	this.p.children[0].src= '/src/assets/img/icono-promocion-gris.png';	
				this.i = this.$refs.investigacion;	
				this.i.children[0].src= '/src/assets/img/icono-investigacion-gris.png';	
				this.m = this.$refs.mercadotecnia;
				this.m.children[0].src= '/src/assets/img/icono-mercadotecnia-gris.png';	
				this.c = this.$refs.capacitacion;
				this.c.children[0].src= '/src/assets/img/icono-capacitacion-hover.png';
				break;
				
			default:
                           
        }

	//   this.src = '';
	//   console.log(this.$refs.referencia.$el)
    }
  
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: #b21621;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

/* Container around content */
.tm-container {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.tm-container::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -12px;
  background-color: white;
  border: 4px solid #b21621;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 50%;
}

/* Add arrows to the left container (pointing right) */
.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid #b21621;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid #b21621;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
  left: -12px;
}

/* The actual content */
.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
/* Place the timelime to the left */
  .timeline::after {
    left: 31px;
  }

/* Full-width containers */
  .tm-container {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

/* Make sure that all arrows are pointing leftwards */
  .tm-container::before {
    left: 60px;
    border: medium solid #b21621;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

/* Make sure all circles are at the same spot */
  .left::after, .right::after {
    left: 18px;
  }

/* Make all right containers behave like the left ones */
  .right {
    left: 0%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/services/Services.vue